import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import * as global from '../../global';
import { API_URL } from "../../../../environments/api-url";
import { AuthService } from 'src/app/services/auth.service';
import { PatientListService } from 'src/app/includes/patient-list/patient-list-service';
import { lastValueFrom } from 'rxjs';
import { ToastrService } from 'ngx-toastr';
import { DashboardService } from '../../dashboard/dashboard.service';
import { FileExplorerService } from '../../drive/file-explorer/file-explorer.service';

@Injectable({
  providedIn: 'root',
})
export class FaceSheetService {
  currentUser: any;
  constructor(
    private httpclient: HttpClient, 
    private authService: AuthService,
    private patientService: PatientListService,
    private toastr:ToastrService,
    private dashboardService:DashboardService,
    private fileExplorerService:FileExplorerService
  ) {
    this.currentUser = authService.currentUser
  }

  uploadFaceSheet(file, patient_id, company_id) {
    const payload = {
      id: this.currentUser._id,
      auth_key: this.currentUser.auth_key,
      usertype: this.currentUser.user_type,
      title: file.name,
      patient_id:patient_id,
      company_id:company_id,
    };
    const formData: any = new FormData();
    formData.append('file', file);

    for (let key of Object.keys(payload)) {
      formData.append(key, payload[key]);
    }
    return this.httpclient.post(global.url + API_URL.FACE_SHEET.uploadFaceSheet, formData).pipe();
  }

  deleteFaceSheet(faceSheetId) {
    const payload = {
      id: this.currentUser._id,
      auth_key: this.currentUser.auth_key,
      usertype: this.currentUser.user_type,
      faceSheetId
    };
    return this.httpclient.post(global.url + API_URL.FACE_SHEET.deleteFaceSheet, payload).pipe();
  }

  getFacesheet(patient_id) {
    const payload = {
      patient_id : patient_id
    }
    return this.httpclient.post(global.url + API_URL.FACE_SHEET.getFacesheet, payload).pipe();
  }

  checkFacesheetStatusForCompany(company_id) {
    const payload = {
      company_id : company_id
    }
    return this.httpclient.post(global.url + API_URL.FACE_SHEET.checkFacesheetStatusForCompany, payload).pipe();
  }

  checkFacesheetExtactionForCompany(company_id) {
    const payload = {
      company_id : company_id
    }
    return this.httpclient.post(global.url + API_URL.FACE_SHEET.checkFacesheetExtactionForCompany, payload).pipe();
  }

  getCoveragesData(data) {
    return this.httpclient
        .post(global.url + API_URL.PATIENT.getCoveragesData, data).pipe();
  }
  async generateFacesheetAndDownloadAsPDF(coverageData = {}, details = {} ) { 
    try { 
      if(Object.keys(coverageData).length === 0){
        this.toastr.info('Collecting Data', 'Please wait...');
        const {status, data} =  await lastValueFrom(this.getCoveragesData({details})) as any;
        if(status === 200){
          let faceSheetData = {
            patient: data.patient_data || {},
            coverages: data.coverage_data || []
          } 
          this.toastr.clear();
          this.downloadFacesheetAsPDF(faceSheetData);
        } else {
          this.toastr.error('Failed to collect data');
          return;
        }
      }
      else{ 
        this.downloadFacesheetAsPDF(coverageData);
      }
        
    } catch (error) {
        const { message = 'Something went wrong, please try again' } = error;
        this.toastr.error(message);
    } finally {
    }
  }

  private handleFileDownload(res: any, fileName: string) {
    try {
      const url = window.URL.createObjectURL(res);
      const a = document.createElement('a');
      document.body.appendChild(a);
      a.style.display = 'none';
      a.href = url;
      a.download = fileName;
      a.click();
      window.URL.revokeObjectURL(url);
      a.remove();
      return;
    } 
    catch (error) {
      this.toastr.error('An error occurred while processing the file.', 'Error');
    }
  }
  
  downloadFacesheetAsPDF(params: any) {
    this.toastr.info('Downloading Face Sheet', 'Please wait...');
    return this.dashboardService
      .downloadFile(global.url + API_URL.PATIENT.generateFacesheetAndDownloadAsPDF, params)
      .subscribe({
        next: (res: any) => {
          if (res instanceof HttpResponse) {
            this.handleFileDownload(res.body, 'facesheet.pdf');
          } else if (res.type === 3) {
            const { loaded, total } = res;
            const progress = Math.round((loaded / total) * 100);
            if (progress > 0) {
              // Optionally handle progress here
            }
          }
        },
        error: (error) => {
          console.error('Error during facesheet download:', error);
          if (error.status === 404) {
            this.toastr.error('File not found.', 'Download Failed');
          } else if (error.status === 500) {
            this.toastr.error('Internal server error. Please try again later.', 'Download Failed');
          } else {
            this.toastr.error('An unexpected error occurred. Please try again.', 'Download Failed');
          }
        },
        complete: () => {
          this.toastr.success('File downloaded successfully.');
        },
      });
  }

  downloadUploadedFile(aws_path: string, title: string, patient_id: string) {
    this.toastr.info('Preparing file to download...', 'Please wait');
    
    this.fileExplorerService.downLoadAnyFileWithURL(aws_path, title, patient_id).subscribe({
      next: (res: any) => {
        this.handleFileDownload(res, title);
      },
      error: (error: any) => {
        console.error('Error during file download:', error);
        if (error.status === 404) {
          this.toastr.error('File not found on the server.', 'Download Failed');
        } else if (error.status === 500) {
          this.toastr.error('Server encountered an error. Please try again later.', 'Download Failed');
        } else {
          this.toastr.error('An unexpected error occurred. Please try again.', 'Download Failed');
        }
      },
      complete: () => {
        this.toastr.success('File downloaded successfully.');
      },
    });
  }
  
  
}
